import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyLink } from 'gatsby-theme-thepuzzlers-core';
import { useLocation } from '@gatsbyjs/reach-router';

// helper functions
import { useRevertPathToDefaultLocale, useLocalizePath } from '../utils/hooks';
import { useIntlContext } from '../utils/context/intl-context';
import { useIntl } from 'react-intl';

export const LanguageSwitchLink = ({
  children,
  language,
  variant,
  ...props
}) => {
  const location = useLocation();
  const { locale } = useIntl();
  const { locales } = useIntlContext();
  const cleanedPathname = useRevertPathToDefaultLocale(location?.pathname);
  const localizedPath = useLocalizePath(
    cleanedPathname,
    // if no langugae given, we localize path for default language of website
    language || locales.default
  );

  return (
    <GatsbyLink
      to={localizedPath}
      variant={variant}
      active={locale === language}
      {...props}>
      {children}
    </GatsbyLink>
  );
};

LanguageSwitchLink.propTypes = {
  /* Language is specified if not the default */
  language: PropTypes.string,
  variant: PropTypes.string
};

LanguageSwitchLink.defaultProps = {
  language: null,
  variant: 'languageSwitch'
};
